// Shows a spinner over content that is loading. The content stays mounted, so
// its scroll position and form state survive the load. While spinning it fades
// and ignores the mouse, and the spinner sits centered over the top 384px of it,
// so a tall list does not push the spinner out of view.

import type { ReactNode } from "react";

import { cn } from "../../shadcn/lib/utils";
import { Spinner } from "./Spinner";

export interface SpinnerOverlayProps {
  spinning: boolean;
  children?: ReactNode;
  /** Spinner diameter in pixels. */
  size?: number;
  className?: string;
}

export function SpinnerOverlay({
  spinning,
  children,
  size = 20,
  className,
}: SpinnerOverlayProps) {
  return (
    <div className={cn("relative", className)} aria-busy={spinning}>
      <div
        className={cn(
          "transition-opacity",
          spinning && "pointer-events-none opacity-50 select-none",
        )}
      >
        {children}
      </div>
      {spinning && (
        <Spinner
          size={size}
          className="absolute inset-x-0 top-0 z-10 h-full max-h-96"
        />
      )}
    </div>
  );
}
